<div class="print-page" *ngIf="quote_info && presentation_info">
	<!-- HEADER -->
	<div class="d-flex justify-content-between align-items-center mb-4">
		<div class="store-logo">
			<img [src]="rest.getImagePath(store.ticket_image_id)" style="max-height: 100px;">
		</div>
		<div class="text-end">
			<h1 class="h2 mb-0">COTIZACIÓN</h1>
			<div class="text-muted">{{presentation_info.presentation.symbology}}</div>
			<div class="mt-2">
				<strong>Fecha:</strong> {{quote_info.quote.created | date:'longDate'}}<br>
				<strong>Vigencia:</strong> {{quote_info.quote.valid_until | date:'longDate'}}
			</div>
		</div>
	</div>

	<hr>

	<!-- CLIENT & PROJECT INFO -->
	<div class="row mb-4">
		<div class="col-6">
			<h6 class="text-primary text-uppercase small fw-bold mb-2">Cliente</h6>
			<div class="fw-bold">{{quote_info.quote.name | uppercase}}</div>
			<div *ngIf="quote_info.quote.email">{{quote_info.quote.email}}</div>
			<div *ngIf="quote_info.quote.phone">{{quote_info.quote.phone}}</div>
		</div>
		<div class="col-6 text-end">
			<h6 class="text-primary text-uppercase small fw-bold mb-2">Proyecto</h6>
			<div class="fw-bold h5">{{presentation_info.presentation.project_name}}</div>
		</div>
	</div>

	<!-- VISUALS GRID -->
	<div class="row g-3 mb-4" *ngIf="getPrimaryVisuals().length > 0">
		<div [class]="getPrimaryVisuals().length === 1 ? 'col-12' : 'col-6'" *ngFor="let img of getPrimaryVisuals()">
			<div class="visual-container">
				<img [src]="rest.getImagePath(img.image_id)" class="img-fluid rounded shadow-sm w-100" style="height: 300px; object-fit: cover;">
			</div>
		</div>
	</div>

	<!-- SECTIONS -->
	<div *ngFor="let sInfo of presentation_info.sections" class="mb-4">
		<div class="section-header bg-light p-2 mb-2 border-start border-primary border-4 d-flex justify-content-between align-items-center">
			<h5 class="mb-0 text-primary">{{sInfo.section.name}}</h5>
			<div class="fw-bold" *ngIf="sInfo.section.price_display_mode === 'SUM'">
				{{ getSectionTotal(sInfo.section.id) | currency }}
			</div>
		</div>

		<div class="ps-3 mb-3">
			<div *ngFor="let row of sInfo.rows" class="mb-2">
				<div class="row">
					<div class="col-4 fw-bold small text-muted text-uppercase" *ngIf="row.label">{{row.label}}</div>
					<div [class]="row.label ? 'col-8' : 'col-12'" class="text-justify">{{row.description}}</div>
				</div>
			</div>
		</div>

		<!-- SECTION IMAGES -->
		<div class="ps-3 mb-3 row g-2" *ngIf="sInfo.images.length > 0">
			<div class="col-4" *ngFor="let img of sInfo.images">
				<img [src]="rest.getImagePath(img.image_id)" class="img-fluid rounded border shadow-sm w-100" style="height: 150px; object-fit: cover;">
			</div>
		</div>

		<!-- DETAILED ITEMS IF REQUESTED -->
		<div class="ps-3" *ngIf="sInfo.section.price_display_mode === 'DETAILED'">
			<table class="table table-sm small">
				<thead>
					<tr class="table-light">
						<th>Descripción</th>
						<th class="text-end">Cantidad</th>
						<th class="text-end">P. Unitario</th>
						<th class="text-end">Total</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let link of sInfo.links">
						<td>{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.item?.name }}</td>
						<td class="text-end">{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.quote_item?.qty }}</td>
						<td class="text-end">{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.quote_item?.unitary_price | currency }}</td>
						<td class="text-end">{{ (quote_info.items | findQuoteItem:link.quote_item_id)?.quote_item?.total | currency }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- SUPPORTING DETAILS IMAGES -->
	<div class="row g-2 mb-4" *ngIf="getSupportingDetails().length > 0">
		<div class="col-3" *ngFor="let img of getSupportingDetails()">
			<img [src]="rest.getImagePath(img.image_id)" class="img-fluid rounded border shadow-sm w-100" style="height: 120px; object-fit: cover;">
		</div>
	</div>

	<!-- TOTALS -->
	<div class="row mt-5">
		<div class="col-7">
			<div class="small text-muted mb-2"><strong>IMPORTANTE:</strong></div>
			<div class="small text-muted" style="font-size: 0.75rem;">
				* Precios sujetos a cambios sin previo aviso.<br>
				* Esta cotización tiene una vigencia de {{quote_info.quote.valid_until | date:'shortDate'}}.<br>
				* Condiciones de pago: Contado a menos que se especifique lo contrario.
			</div>
		</div>
		<div class="col-5">
			<div class="d-flex justify-content-between border-top pt-2">
				<span class="fw-bold">Subtotal:</span>
				<span>{{quote_info.quote.subtotal | currency}}</span>
			</div>
			<div class="d-flex justify-content-between">
				<span class="fw-bold">I.V.A:</span>
				<span>{{quote_info.quote.tax | currency}}</span>
			</div>
			<div class="d-flex justify-content-between h4 mt-2 border-top border-primary border-2 pt-2">
				<span class="fw-bold text-primary">TOTAL:</span>
				<span class="fw-bold text-primary">{{quote_info.quote.total | currency}} {{quote_info.quote.currency_id}}</span>
			</div>
			<div class="text-end small fw-bold mt-1">
				{{total_letra}} {{quote_info.quote.currency_id}} {{currency.name | uppercase}}
			</div>
		</div>
	</div>

	<!-- FOOTER -->
	<div class="mt-5 pt-5 text-center text-muted small border-top">
		<div>{{store.name}} - {{store.address}}</div>
		<div *ngIf="store.phone">Tel: {{store.phone}}</div>
	</div>
</div>
